@if (organisationCheckCompleted) {
  <router-outlet></router-outlet>
}
